// // this code for to add sevak from group list.=> groupid/new sevak

// import React, { useState, useEffect } from "react";
// import { doc, updateDoc, arrayUnion } from "firebase/firestore";
// import { db } from "../firebase";
// import { saveSevakData } from "../firebase";

// const initialFormState = {
//   designation: "",
//   accountId: "",
//   AdharNumber: "",
//   sevakName: "",
//   surName: "",
//   fatherOrSpouseName: "",
//   dob: "",
//   age: "",
//   mobileNo: "",
//   email: "",
//   qualification: "",
//   profession: "",
//   designation: "",
//   specialisation: "",
//   placeOfWork: "",
//   country: "",
//   state: "",
//   district: "",
//   city: "",
//   street: "",
//   doorNo: "",
//   pincode: "",
//   nearestTtdTemple: "SV Temple, Jubilee Hills, Hyderabad, Chennai",
//   mentallyFit: true,
//   physicallyFit: true,
// };

// const SevakForm = ({ groupId, groupData, onSevakAdded, editMode = false, sevakToEdit = null  }) => {
//   // const [formData, setFormData] = useState(initialFormState);
//   const [formData, setFormData] = useState(editMode && sevakToEdit ? sevakToEdit : initialFormState);

//   const [imagePreview, setImagePreview] = useState(null);

//   useEffect(() => {
//   if (editMode && sevakToEdit) {
//     setFormData(sevakToEdit);
//   }
// }, [editMode, sevakToEdit]);


//   // Calculate min and max dates
//   const today = new Date();
//   const minDate = new Date(
//     today.getFullYear() - 80,
//     today.getMonth(),
//     today.getDate()
//   );
//   const maxDate = new Date(
//     today.getFullYear() - 18,
//     today.getMonth(),
//     today.getDate()
//   );

//   const formatDate = (date) => {
//     return date.toISOString().split("T")[0]; // YYYY-MM-DD
//   };

//   const calculateAge = (dob) => {
//     const birthDate = new Date(dob);
//     const ageDifMs = today - birthDate;
//     const ageDate = new Date(ageDifMs);
//     return Math.abs(ageDate.getUTCFullYear() - 1970);
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name === "dob") {
//       const age = calculateAge(value);
//       setFormData((prev) => ({
//         ...prev,
//         dob: value,
//         age: age,
//       }));
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: type === "checkbox" ? checked : value,
//       }));
//     }
//   };

//   const formatDOB = (isoDate) => {
//     const [year, month, day] = isoDate.split("-");
//     return `${day}/${month}/${year}`;
//   };

//   // ✅ Convert a File or Blob to a Base64 Data URL
//   const fileOrBlobToDataURL = (fileOrBlob) =>
//     new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => resolve(reader.result); // data:image/*;base64,...
//       reader.onerror = reject;
//       reader.readAsDataURL(fileOrBlob);
//     });

//   // ✅ Convert an image URL to a Base64 Data URL (useful in edit mode)
//   async function urlToDataURL(url) {
//     const res = await fetch(url);
//     const blob = await res.blob();
//     return await fileOrBlobToDataURL(blob);
//   }

//   // ✅ Image upload -> store as Base64 (Data URL)
//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const dataUrl = await fileOrBlobToDataURL(file);

//     setImagePreview(dataUrl);

//     setFormData((prev) => ({
//       ...prev,
//       profilePicBase64: dataUrl, // store base64
//       // clear any file/url fields used earlier
//       profilePicFile: undefined,
//       profilePicUrl: "",
//     }));
//   };

//   // ✅ Main submit handler — save Base64 instead of Storage URL
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const formattedDOB = formatDOB(formData.dob);

//       // Final Base64 to persist
//       let imageBase64 = formData.profilePicBase64 || "";

//       // If editing and only URL exists, convert it once
//       if (!imageBase64 && formData.profilePicUrl) {
//         imageBase64 = await urlToDataURL(formData.profilePicUrl);
//       }

//       const groupRef = doc(db, "sevakGroups", groupId);

//       if (editMode) {
//         // ✅ Update existing Sevak
//         const updatedSevak = {
//           ...formData,
//           dob: formattedDOB,
//           profilePicBase64: imageBase64,
//         };

//         const { profilePicFile, profilePicUrl, ...sevakDataToSave } = updatedSevak;

//         const updatedMembers = groupData.members.map((m) =>
//           m.AdharNumber === sevakDataToSave.AdharNumber ? sevakDataToSave : m
//         );

//         await updateDoc(groupRef, { members: updatedMembers });
//         alert("Sevak updated successfully");

//         if (onSevakAdded) {
//           onSevakAdded(sevakDataToSave);
//         }
//       } else {
//         // ✅ Add new Sevak
//         const currentCount = groupData?.members?.length || 0;
//         if (currentCount >= 15) {
//           alert("Maximum 15 Sevaks allowed per group.");
//           return;
//         }

//         const accountId = `${groupId}${currentCount + 1}`;
//         const imageId = `${accountId}_image`;
//         const designation = currentCount === 0 ? "teamleader" : "member";

//         const newSevak = {
//           ...formData,
//           dob: formattedDOB,
//           accountId,
//           imageId,
//           profilePicBase64: imageBase64,
//           designation,
//         };

//         const { profilePicFile, profilePicUrl, ...sevakDataToSave } = newSevak;

//         await updateDoc(groupRef, {
//           members: arrayUnion(sevakDataToSave),
//         });

//         alert("Sevak added successfully");

//         if (onSevakAdded) {
//           onSevakAdded(sevakDataToSave);
//         }
//       }

//       setImagePreview(null);
//       setFormData(initialFormState);
//     } catch (error) {
//       console.error("Error saving sevak:", error);
//       alert("Failed to save sevak");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="row g-3">
//       <div className="col-md-3">
//         {imagePreview && (
//           <div style={{ marginTop: "10px" }}>
//             {" "}
//             <img
//               src={imagePreview}
//               alt="Preview"
//               style={{
//                 width: "150px",
//                 height: "150px",
//                 objectFit: "cover",
//                 borderRadius: "8px",
//               }}
//             />{" "}
//           </div>
//         )}
//         <input
//           type="file"
//           accept="image/*"
//           name="profilePic"
//           id="sevakImage"
//           onChange={handleImageUpload}
//         />
//         <label htmlFor="sevakImage" className="form-label">
//           Upload Image
//         </label>
//       </div>
//       <div className="col-md-5">
//         <label htmlFor="AdharNumber" className="form-label">
//           Adhar Number
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="idNumber"
//           name="AdharNumber"
//           value={formData.AdharNumber}
//           onChange={handleChange}
//           required
//         />
//       </div>
//       <div className="col-md-4">
//         <label htmlFor="sevakName" className="form-label">
//           Name
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="sevakName"
//           name="sevakName"
//           value={formData.sevakName}
//           onChange={handleChange}
//           required
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="surName" className="form-label">
//           Surname
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="surName"
//           name="surName"
//           value={formData.surName}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="fatherOrSpouseName" className="form-label">
//           Father/Spouse Name
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="fatherOrSpouseName"
//           name="fatherOrSpouseName"
//           value={formData.fatherOrSpouseName}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-3">
//         <label htmlFor="dob" className="form-label">
//           Date of Birth
//         </label>
//         <input
//           type="date"
//           className="form-control"
//           id="dob"
//           name="dob"
//           value={formData.dob}
//           onChange={handleChange}
//           min={formatDate(minDate)}
//           max={formatDate(maxDate)}
//           pattern="\d{4}-\d{2}-\d{2}"
//           required
//         />
//       </div>
//       <div className="col-md-3">
//         <label htmlFor="age" className="form-label">
//           Age
//         </label>
//         <input
//           type="number"
//           className="form-control"
//           id="age"
//           name="age"
//           value={formData.age}
//           onChange={handleChange}
//           readOnly
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="mobileNo" className="form-label">
//           Mobile Number
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="mobileNo"
//           name="mobileNo"
//           value={formData.mobileNo}
//           onChange={handleChange}
//           maxLength="10"
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="email" className="form-label">
//           Email
//         </label>
//         <input
//           type="email"
//           className="form-control"
//           id="email"
//           name="email"
//           value={formData.email}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-6">
//         <label className="form-label d-block">Fitness</label>
//         <div className="form-check form-check-inline">
//           <input
//             type="checkbox"
//             className="form-check-input"
//             id="mentallyFit"
//             name="mentallyFit"
//             checked={formData.mentallyFit}
//             onChange={handleChange}
//           />
//           <label className="form-check-label" htmlFor="mentallyFit">
//             Mentally Fit
//           </label>
//         </div>
//         <div className="form-check form-check-inline">
//           <input
//             type="checkbox"
//             className="form-check-input"
//             id="physicallyFit"
//             name="physicallyFit"
//             checked={formData.physicallyFit}
//             onChange={handleChange}
//           />
//           <label className="form-check-label" htmlFor="physicallyFit">
//             Physically Fit
//           </label>
//         </div>
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="profession" className="form-label">
//           Profession
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="profession"
//           name="profession"
//           value={formData.profession}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="country" className="form-label">
//           India
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="country"
//           name="country"
//           value={formData.country}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="state" className="form-label">
//           State
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="state"
//           name="state"
//           value={formData.state}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="district" className="form-label">
//           District
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="district"
//           name="district"
//           value={formData.district}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="city" className="form-label">
//           City
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="city"
//           name="city"
//           value={formData.city}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="street" className="form-label">
//           Street
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="street"
//           name="street"
//           value={formData.street}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-3">
//         <label htmlFor="doorNo" className="form-label">
//           Door No
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="doorNo"
//           name="doorNo"
//           value={formData.doorNo}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-md-3">
//         <label htmlFor="pincode" className="form-label">
//           Pincode
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="pincode"
//           name="pincode"
//           value={formData.pincode}
//           onChange={handleChange}
//           maxLength="6"
//         />
//       </div>
//       <div className="col-md-6">
//         <label htmlFor="nearestTtdTemple" className="form-label">
//           Nearest TTD Temple
//         </label>
//         <input
//           type="text"
//           className="form-control"
//           id="nearestTtdTemple"
//           name="nearestTtdTemple"
//           value={formData.nearestTtdTemple}
//           onChange={handleChange}
//         />
//       </div>
//       <div className="col-12 text-center mt-3">
//         <button type="submit" id="sevakSumbit" className="btn btn-primary">
//           Save and Add Sevak
//         </button>
//       </div>
//     </form>
//   );
// };

// export default SevakForm;

// this code for to add sevak from group list.=> groupid/new sevak

import React, { useState, useEffect } from "react";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from "../firebase";
import { saveSevakData } from "../firebase";

const initialFormState = {
  designation: "",
  accountId: "",
  AdharNumber: "",
  sevakName: "",
  surName: "",
  fatherOrSpouseName: "",
  dob: "",
  age: "",
  mobileNo: "",
  email: "",
  qualification: "",
  profession: "",
  designation: "",
  specialisation: "",
  placeOfWork: "",
  country: "",
  state: "",
  district: "",
  city: "",
  street: "",
  doorNo: "",
  pincode: "",
  nearestTtdTemple: "SV Temple, Jubilee Hills, Hyderabad, Chennai",
  mentallyFit: true,
  physicallyFit: true,
};

const SevakForm = ({ groupId, groupData, onSevakAdded, editMode = false, sevakToEdit = null }) => {
  // const [formData, setFormData] = useState(initialFormState);
  const [formData, setFormData] = useState(editMode && sevakToEdit ? sevakToEdit : initialFormState);

  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    if (editMode && sevakToEdit) {
      setFormData(sevakToEdit);
    }
  }, [editMode, sevakToEdit]);


  // Calculate min and max dates
  const today = new Date();
  const minDate = new Date(
    today.getFullYear() - 80,
    today.getMonth(),
    today.getDate()
  );
  const maxDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );

  const formatDate = (date) => {
    return date.toISOString().split("T")[0]; // YYYY-MM-DD
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const ageDifMs = today - birthDate;
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "dob") {
      const age = calculateAge(value);
      setFormData((prev) => ({
        ...prev,
        dob: value,
        age: age,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const formatDOB = (isoDate) => {
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  // ✅ Convert a File or Blob to a Base64 Data URL
  const fileOrBlobToDataURL = (fileOrBlob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result); // data:image/*;base64,...
      reader.onerror = reject;
      reader.readAsDataURL(fileOrBlob);
    });

  // ✅ Convert an image URL to a Base64 Data URL (useful in edit mode)
  async function urlToDataURL(url) {
    const res = await fetch(url);
    const blob = await res.blob();
    return await fileOrBlobToDataURL(blob);
  }

  // ✅ Image upload -> store as Base64 (Data URL)
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const dataUrl = await fileOrBlobToDataURL(file);

    setImagePreview(dataUrl);

    setFormData((prev) => ({
      ...prev,
      profilePicBase64: dataUrl, // store base64
      // clear any file/url fields used earlier
      profilePicFile: undefined,
      profilePicUrl: "",
    }));
  };

  // ✅ Main submit handler — save Base64 instead of Storage URL
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formattedDOB = formatDOB(formData.dob);

      // Final Base64 to persist
      let imageBase64 = formData.profilePicBase64 || "";

      // If editing and only URL exists, convert it once
      if (!imageBase64 && formData.profilePicUrl) {
        imageBase64 = await urlToDataURL(formData.profilePicUrl);
      }

      const groupRef = doc(db, "sevakGroups", groupId);

      if (editMode) {
        // ✅ Update existing Sevak
        const updatedSevak = {
          ...formData,
          dob: formattedDOB,
          profilePicBase64: imageBase64,
        };

        const { profilePicFile, profilePicUrl, ...sevakDataToSave } = updatedSevak;

        const updatedMembers = groupData.members.map((m) =>
          m.AdharNumber === sevakDataToSave.AdharNumber ? sevakDataToSave : m
        );

        await updateDoc(groupRef, { members: updatedMembers });
        alert("Sevak updated successfully");

        if (onSevakAdded) {
          onSevakAdded(sevakDataToSave);
        }
      } else {
        // ✅ Add new Sevak
        const currentCount = groupData?.members?.length || 0;
        if (currentCount >= 15) {
          alert("Maximum 15 Sevaks allowed per group.");
          return;
        }

        const accountId = `${groupId}${currentCount + 1}`;
        const imageId = `${accountId}_image`;
        const designation = currentCount === 0 ? "teamleader" : "member";

        const newSevak = {
          ...formData,
          dob: formattedDOB,
          accountId,
          imageId,
          profilePicBase64: imageBase64,
          designation,
        };

        const { profilePicFile, profilePicUrl, ...sevakDataToSave } = newSevak;

        await updateDoc(groupRef, {
          members: arrayUnion(sevakDataToSave),
        });

        alert("Sevak added successfully");

        if (onSevakAdded) {
          onSevakAdded(sevakDataToSave);
        }
      }

      setImagePreview(null);
      setFormData(initialFormState);
    } catch (error) {
      console.error("Error saving sevak:", error);
      alert("Failed to save sevak");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="row g-3">
      <div className="col-md-3">
        {imagePreview && (
          <div style={{ marginTop: "10px" }}>
            {" "}
            <img
              src={imagePreview}
              alt="Preview"
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />{" "}
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          name="profilePic"
          id="sevakImage"
          onChange={handleImageUpload}
        />
        <label htmlFor="sevakImage" className="form-label">
          Upload Image
        </label>
      </div>
      <div className="col-md-5">
        <label htmlFor="AdharNumber" className="form-label">
          Adhar Number
        </label>
        <input
          type="text"
          className="form-control"
          id="idNumber"
          name="AdharNumber"
          value={formData.AdharNumber}
          onChange={handleChange}
          required
        />
      </div>
      <div className="col-md-4">
        <label htmlFor="sevakName" className="form-label">
          Name
        </label>
        <input
          type="text"
          className="form-control"
          id="sevakName"
          name="sevakName"
          value={formData.sevakName}
          onChange={handleChange}
          required
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="surName" className="form-label">
          Surname
        </label>
        <input
          type="text"
          className="form-control"
          id="surName"
          name="surName"
          value={formData.surName}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="fatherOrSpouseName" className="form-label">
          Father/Spouse Name
        </label>
        <input
          type="text"
          className="form-control"
          id="fatherOrSpouseName"
          name="fatherOrSpouseName"
          value={formData.fatherOrSpouseName}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="dob" className="form-label">
          Date of Birth
        </label>
        <input
          type="date"
          className="form-control"
          id="dob"
          name="dob"
          value={formData.dob}
          onChange={handleChange}
          min={formatDate(minDate)}
          max={formatDate(maxDate)}
          pattern="\d{4}-\d{2}-\d{2}"
          required
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="age" className="form-label">
          Age
        </label>
        <input
          type="number"
          className="form-control"
          id="age"
          name="age"
          value={formData.age}
          onChange={handleChange}
          readOnly
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="mobileNo" className="form-label">
          Mobile Number
        </label>
        <input
          type="text"
          className="form-control"
          id="mobileNo"
          name="mobileNo"
          value={formData.mobileNo}
          onChange={handleChange}
          maxLength="10"
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="email" className="form-label">
          Email
        </label>
        <input
          type="email"
          className="form-control"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label className="form-label d-block">Fitness</label>
        <div className="form-check form-check-inline">
          <input
            type="checkbox"
            className="form-check-input"
            id="mentallyFit"
            name="mentallyFit"
            checked={formData.mentallyFit}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="mentallyFit">
            Mentally Fit
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            type="checkbox"
            className="form-check-input"
            id="physicallyFit"
            name="physicallyFit"
            checked={formData.physicallyFit}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="physicallyFit">
            Physically Fit
          </label>
        </div>
      </div>
      <div className="col-md-6">
        <label htmlFor="profession" className="form-label">
          Profession
        </label>
        <input
          type="text"
          className="form-control"
          id="profession"
          name="profession"
          value={formData.profession}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="country" className="form-label">
          India
        </label>
        <input
          type="text"
          className="form-control"
          id="country"
          name="country"
          value={formData.country}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="state" className="form-label">
          State
        </label>
        <input
          type="text"
          className="form-control"
          id="state"
          name="state"
          value={formData.state}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="district" className="form-label">
          District
        </label>
        <input
          type="text"
          className="form-control"
          id="district"
          name="district"
          value={formData.district}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="city" className="form-label">
          City
        </label>
        <input
          type="text"
          className="form-control"
          id="city"
          name="city"
          value={formData.city}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="street" className="form-label">
          Street
        </label>
        <input
          type="text"
          className="form-control"
          id="street"
          name="street"
          value={formData.street}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="doorNo" className="form-label">
          Door No
        </label>
        <input
          type="text"
          className="form-control"
          id="doorNo"
          name="doorNo"
          value={formData.doorNo}
          onChange={handleChange}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="pincode" className="form-label">
          Pincode
        </label>
        <input
          type="text"
          className="form-control"
          id="pincode"
          name="pincode"
          value={formData.pincode}
          onChange={handleChange}
          maxLength="6"
        />
      </div>
      <div className="col-md-6">
        <label htmlFor="nearestTtdTemple" className="form-label">
          Nearest TTD Temple
        </label>
        <input
          type="text"
          className="form-control"
          id="nearestTtdTemple"
          name="nearestTtdTemple"
          value={formData.nearestTtdTemple}
          onChange={handleChange}
        />
      </div>
      <div className="col-12 text-center mt-3">
        <button type="submit" id="sevakSumbit" className="btn btn-primary">
          Save and Add Sevak
        </button>
      </div>
    </form>
  );
};

export default SevakForm;